import { http } from '../http-common';

export type CompanyEvaluationPayload = {
  companyId: number;
  answers: Array<{
    criteriaId: number;
    selectedOptionId: number;
  }>;
};

const create = (data: CompanyEvaluationPayload) => {
  return http.post<any>('/company-evaluations', data);
};

const getLatestByCompanyId = (companyId: number) => {
  return http.get<any>(`/company-evaluations/company/${companyId}/latest`);
};

const CompanyEvaluationService = {
  create,
  getLatestByCompanyId,
};

export default CompanyEvaluationService;
